export default __webpack_public_path__ + "static/media/trees_for_cities_logo.5986c425.png";